import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { AnchorLink } from './AnchorLink';
import { DEPARTEMENTS } from '../data/departements';

const LINKS = {
  services: [
    { name: 'Location de benne', hash: 'tarifs' },
    { name: 'Quelle benne choisir ?', hash: 'quelle-benne' },
    { name: 'Conditions de location', hash: 'conditions' },
    { name: 'Comment ça marche', hash: 'comment' },
  ],
  company: [
    { name: 'À propos', hash: 'notre-experience' },
    { name: 'Nos engagements', hash: 'engagements' },
    { name: 'Zones d\'intervention', hash: 'zones' },
    { name: 'Questions fréquentes', hash: 'faq' },
  ],
  compte: [
    { name: 'Commander sans compte', to: '/commander-sans-compte' },
    { name: 'Créer un compte', to: '/inscription' },
    { name: 'Conditions d’utilisation', to: '/cgu' },
    { name: 'Conditions de vente', to: '/cgv' },
    { name: 'Se connecter', to: '/connexion' },
  ],
};

const linkClass = 'hover:text-green-500 transition-colors text-sm';

const Footer = () => (
  <footer className="bg-gray-900 text-gray-300" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-2">
          <div className="flex items-start mb-4">
            <img src="/logo-ler.png" alt="Location Benne Chantier" className="h-20 w-auto object-contain drop-shadow-lg" />
          </div>
          <p className="text-gray-400 mb-6 leading-relaxed">
            Location de bennes de chantier et gestion de vos déchets en Île-de-France, pour les professionnels et les particuliers.
          </p>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <Phone className="h-5 w-5 text-green-500" />
              <a href="tel:0745558835" className="hover:text-green-500 transition-colors" data-testid="footer-phone">07 45 55 88 35</a>
            </div>
            <div className="flex items-center space-x-3">
              <Mail className="h-5 w-5 text-green-500" />
              <a href="mailto:contact@locationbennechantier.com" className="hover:text-green-500 transition-colors" data-testid="footer-email">contact@locationbennechantier.com</a>
            </div>
            <div className="flex items-center space-x-3">
              <MapPin className="h-5 w-5 text-green-500" />
              <span>Île-de-France</span>
            </div>
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Services</h4>
          <ul className="space-y-2" data-testid="footer-services">
            {LINKS.services.map((l) => (
              <li key={l.hash}><AnchorLink hash={l.hash} className={linkClass} data-testid={`footer-link-${l.hash}`}>{l.name}</AnchorLink></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Entreprise</h4>
          <ul className="space-y-2" data-testid="footer-company">
            {LINKS.company.map((l) => (
              <li key={l.hash}><AnchorLink hash={l.hash} className={linkClass} data-testid={`footer-link-${l.hash}`}>{l.name}</AnchorLink></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Espace client</h4>
          <ul className="space-y-2" data-testid="footer-compte">
            {LINKS.compte.map((l) => (
              <li key={l.to}><Link to={l.to} className={linkClass} data-testid={`footer-link${l.to.replace(/\//g, '-')}`}>{l.name}</Link></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-gray-800">
        <h4 className="text-white font-bold mb-4">Location de benne par département</h4>
        <ul className="flex flex-wrap gap-x-6 gap-y-2" data-testid="footer-departements">
          {DEPARTEMENTS.map((d) => (
            <li key={d.code}>
              <Link to={d.path} className={linkClass}>Location benne {d.nom} ({d.code})</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <p className="text-sm text-gray-400 text-center md:text-left">
          © {new Date().getFullYear()} Location Benne Chantier. Tous droits réservés.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
